import * as React from "react";
import { useEffect, useState } from "react";
import * as Immutable from "immutable";
import SectionComponent from "components/common/Section/SectionComponent";
import { LinkContainer, ReadOnlyFormGroup, Spinner } from "components/common";
import Routes from "routing/Routes";
import { Button, Alert, ButtonToolbar } from "components/bootstrap";
import { GroupSyncActions } from "authentication/stores/directoryServices/GroupSyncStore";
import TriggerTeamSyncButton from "authentication/components/TriggerTeamSyncButton";
import { OKTA_TYPE_KEY } from "authentication/components/oidc/constants";
import TriggerTeamSyncResponse from "authentication/components/directoryServices/TriggerTeamSyncResponse";
import LicenseCheck from "license/LicenseCheck";
import OidcConfigSection from "authentication/components/oidc/config/components/OidcConfigSection";
const getRolesList = (roles, defaultRolesIds) => {
  if (!defaultRolesIds || defaultRolesIds.size === 0) {
    return null;
  }
  const defaultRolesNames = defaultRolesIds.map((roleId) => {
    var _a;
    return (_a = roles.find((role) => role.id === roleId)) == null ? void 0 : _a.name;
  });
  return defaultRolesNames.join(", ");
};
export const getReadableSelectionType = (selectionType) => {
  switch (selectionType) {
    case "all":
      return "All matching groups";
    case "include":
      return "Include selected groups";
    case "exclude":
      return "Exclude selected groups";
    default:
      return selectionType;
  }
};
const GroupSyncSection = ({ authenticationBackend, roles }) => {
  const {
    id,
    title: backendTitle,
    config: { type }
  } = authenticationBackend;
  const [groupSyncBackend, setGroupSyncBackend] = useState();
  const [finishedLoading, setFinishedLoading] = useState(false);
  const [triggerSyncResponse, setTriggerSyncResponse] = useState();
  useEffect(() => {
    GroupSyncActions.load(id).then((result) => {
      setGroupSyncBackend(result == null ? void 0 : result.backend);
    }).catch(() => {
      setGroupSyncBackend(void 0);
    }).finally(() => {
      setFinishedLoading(true);
    });
  }, [id]);
  if (!finishedLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const { defaultRoles, selectionType, selection = Immutable.Set() } = groupSyncBackend || {};
  const rolesList = defaultRoles && defaultRoles.size >= 1 ? getRolesList(roles, defaultRoles) : null;
  if (type !== OKTA_TYPE_KEY) {
    return /* @__PURE__ */ React.createElement(
      OidcConfigSection,
      {
        backendId: id,
        groupSyncBackend,
        getReadableSelectionType
      }
    );
  }
  return /* @__PURE__ */ React.createElement(
    SectionComponent,
    {
      title: "Group Synchronization",
      headerActions: /* @__PURE__ */ React.createElement(ButtonToolbar, null, groupSyncBackend && /* @__PURE__ */ React.createElement(TriggerTeamSyncButton, { backendId: id, backendTitle, setResponse: setTriggerSyncResponse }), /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.SYSTEM.AUTHENTICATION.BACKENDS.edit(id, "group_sync") }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "small" }, "Edit")))
    },
    triggerSyncResponse && /* @__PURE__ */ React.createElement(TriggerTeamSyncResponse, { response: triggerSyncResponse }),
    groupSyncBackend ? /* @__PURE__ */ React.createElement(LicenseCheck, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Team Default Roles", value: rolesList }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Okta API Token", value: "************" }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Selection Type", value: getReadableSelectionType(selectionType) }), selectionType !== "all" && /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Selected Groups", value: `${selection.size} group(s)` })) : /* @__PURE__ */ React.createElement(Alert, null, "Okta Group synchronization not configured for this authentication service.")
  );
};
export default GroupSyncSection;
